<app-loading *ngIf="cargando || carEstados"></app-loading>
<div *ngIf="!cargando">
  <div [hidden]="carEstados">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioValidacion" name="nomFormularioValidacion">
      <div class="grid form-group">
        <div class="col-12" style="display: flex">
          <div class="div-form col-4">
            <label>* {{ 'FLUJOVENTAVALIDACIONES.LBL_VALIDACION' | translate }}</label>
            <p-dropdown disableTab  id="idModoAutenticacion" name="nomIdModoAutenticacion"
                        [options]="lisModoAutenticacion"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                         formControlName="idModoAutenticacion"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idModoAutenticacion.invalid">
              {{ 'FLUJOVENTAVALIDACIONES.LBL_VALIDACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
          <div class="div-form col-3 col-offset-1 pt-5">
            <p-checkbox label="{{ 'FLUJOVENTAVALIDACIONES.LBL_REQINTENTOS' | translate}}" binary="true"
                        id="indicadorReintentos"
                        name="nomindicadorReintentos"
                        formControlName="indicadorReintentos"></p-checkbox>
          </div>
          <div class="div-form col-4" *ngIf="f.indicadorReintentos.value">
            <label>* {{ 'FLUJOVENTAVALIDACIONES.LBL_CITENTOS' | translate }}</label>
            <input *ngIf="f.indicadorReintentos.value"
                   type="text" pInputText id="cantidadReintentos" name="nomcantidadReintentos"
                   autocomplete="off"
                   formControlName="cantidadReintentos"
                   [minimo]="0"
                   [maxlength]="3"
                   numero-entero-reactive
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !validarCantidadReintentos()">
              {{mensajeReintento}}
            </div>
          </div>
        </div>
      </div>
      <p-fieldset legend="{{'FLUJOVENTAVALIDACIONES.LBL_COMPORTAMIENTO' | translate}}" class="overflow-y-unset fieldset-border">
        <div class="grid form-group">
          <div class="col-12 md:col-12 lg:col-12">
            <div class="grid">
              <div class="div-form col-6">
                <p-checkbox (onChange)="validarCheckFabrica()"
                            label="{{ 'FLUJOVENTAVALIDACIONES.LBL_FABRICA' | translate}}" binary="true"
                            id="indicadorEnviarFabrica"
                            name="nomindicadorEnviarFabrica"
                            formControlName="indicadorEnviarFabrica"></p-checkbox>
              </div>
              <div class="div-form col-6">
                <p-checkbox (onChange)="validarCheckDeniega()"
                            label="{{ 'FLUJOVENTAVALIDACIONES.LBL_DENIEGA' | translate}}" binary="true"
                            id="indicadorDeniega"
                            name="nomindicadorDeniega"
                            formControlName="indicadorDeniega"></p-checkbox>
              </div>
              <div class="div-form col-12" *ngIf="f.indicadorEnviarFabrica.value">
                <p-checkbox label="{{ 'FLUJOVENTAVALIDACIONES.LBL_REINICIARINTENTOS' | translate}}" binary="true"
                            id="indicadorReiniciarIntentos"
                            name="nomindicadorReiniciarIntentos"
                            formControlName="indicadorReiniciarIntentos"></p-checkbox>
              </div>
              <div class="div-form col-12" *ngIf="f.indicadorEnviarFabrica.value || f.indicadorDeniega.value">
                <label>* {{ 'FLUJOVENTAVALIDACIONES.LBL_CAUSAL' | translate }}</label>
                <p-dropdown disableTab  id="idCausal" name="nomIdCausal"
                            [options]="lisCausaSolicitudes"
                            filter="filter"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                             formControlName="idCausal"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !validarCausal()">
                  {{ 'FLUJOVENTAVALIDACIONES.LBL_CAUSAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-fieldset>

      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
          <button icon="fa fa-plus" label="{{'BTN_GUARDAR'| translate }}"
                  type="button" (click)="onSubmit()"
                  pButton></button>
        </div>
      </div>
    </form>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas"
                 [value]="lisPlatFormDigVal" selectionMode="single" dataKey="idListaPlataformaDigitalVal"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom" [first]="pageActual"  (onPage)="paginaActual($event)">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                  class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>>
          <ng-template pTemplate="body" let-row let-index="rowIndex">
            <tr [pSelectableRow]="row">
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-info btn btnDown" icon="fa fa-arrow-down"
                          data-toggle="tooltip"
                          title="{{'BTN_ABAJO' | translate}}" *ngIf="index >=0 && index<lisPlatFormDigVal.length-1"
                          pButton (click)="cambiarOrden(row, false)"></button>
                  <button type="button" class="p-button p-button-info btn btnUp" icon="fa fa-arrow-up"
                          data-toggle="tooltip"
                          title="{{'BTN_ARRIBA' | translate}}" pButton *ngIf="index >0"
                          (click)="cambiarOrden(row, true)"
                  ></button>
                </div>
              </td>
              <td>{{row.nombreModoAutenticacion}}</td>
              <td>{{row.cantidadReintentos}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorReiniciarIntentos" binary="true" disabled="true"></p-checkbox>
              </td>
              <td>{{row.indicadorEnviarFabrica ? row.nombreCausal: ""}}</td>
              <td>{{row.indicadorDeniega ? row.nombreCausal: ""}}</td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                          title="{{'BTN_EDITAR' | translate}}" pButton
                          (click)="editar(row)"></button>
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton
                          (click)="mensajeEliminar(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog #cd key="flujo-venta-validacion-plataforma">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
